@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

@menu-button-width: 40px;
@alert-height: 13px;

.icon-wrapper {
  display: flex;
  place-content: center center;
  cursor: pointer;

  svg {
    fill: @top-nav--button--fill-color;
  }

  &:hover {
    svg {
      fill: @top-nav--button--hover--fill-color;
    }
  }
  &.anchored {
    svg {
      fill: @app-header--shared-classes-icon-wrapper--fill-color;
    }
  }
  &.anchored:hover {
    svg {
      fill: @app-header--shared-classes-icon-wrapper--hover--fill-color;
    }
  }
}

@CircularAlertCountDecoration: {
  top: -1px;
  background: @top-nav--alert--color;
  font-size: 10px;
  line-height: 10px;
  height: 11px;
  text-align: center;
  padding: 0 2px;
  color: var(--white);
  border-radius: 6px;
  min-width: 11px;
  display: flex;
  justify-content: center;
};
